export function kendoNotification() {
	return $("#staticNotification").kendoNotification({
		appendTo: "#notification-container",
		stacking: "up",
		autoHideAfter: 0,
		show: onShow,
	}).data("kendoNotification");
}

function onShow(e) {
	var timeoutId = e.sender._timeoutId;
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
	if ($('.' + e.sender._guid).hasClass('k-notification-error')) {
		e.sender._timeoutId = setTimeout(function() {
			e.sender.hide();
		}, 6000);
	} else {
		e.sender._timeoutId = setTimeout(function() {
			e.sender.hide();
		}, 3000);
	}
}